import { type Locale } from 'date-fns';
import { arSA } from 'date-fns/locale/ar-SA';
import { ca } from 'date-fns/locale/ca';
import { cs } from 'date-fns/locale/cs';
import { da } from 'date-fns/locale/da';
import { de } from 'date-fns/locale/de';
import { el } from 'date-fns/locale/el';
import { enAU } from 'date-fns/locale/en-AU';
import { enCA } from 'date-fns/locale/en-CA';
import { enGB } from 'date-fns/locale/en-GB';
import { enIE } from 'date-fns/locale/en-IE';
import { enNZ } from 'date-fns/locale/en-NZ';
import { enUS } from 'date-fns/locale/en-US';
import { enZA } from 'date-fns/locale/en-ZA';
import { es } from 'date-fns/locale/es';
import { fr } from 'date-fns/locale/fr';
import { he } from 'date-fns/locale/he';
import { it } from 'date-fns/locale/it';
import { ja } from 'date-fns/locale/ja';
import { ko } from 'date-fns/locale/ko';
import { nl } from 'date-fns/locale/nl';
import { pl } from 'date-fns/locale/pl';
import { pt } from 'date-fns/locale/pt';
import { ptBR } from 'date-fns/locale/pt-BR';
import { ru } from 'date-fns/locale/ru';
import { sv } from 'date-fns/locale/sv';
import { tr } from 'date-fns/locale/tr';
import { zhCN } from 'date-fns/locale/zh-CN';
import { zhTW } from 'date-fns/locale/zh-TW';

// Only the locales present in SUPPORTED_LOCALES — avoids pulling the entire
// date-fns/locale barrel (90+ modules, ~107 KB) into the client bundle.
const LOCALE_MAP: Record<string, Locale> = {
  arSA,
  ca,
  cs,
  da,
  de,
  el,
  enAU,
  enCA,
  enGB,
  enIE,
  enNZ,
  enUS,
  enZA,
  es,
  fr,
  he,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ptBR,
  ru,
  sv,
  tr,
  zhCN,
  zhTW,
};

export default function getDateFnsLocale(locale: string): Locale {
  const [langRaw, regionRaw] = locale.split('-');

  const lang = langRaw.toLowerCase();
  const region = regionRaw?.toUpperCase() ?? '';

  // e.g. en + US => enUS
  const fullKey = region ? `${lang}${region}` : lang;

  return LOCALE_MAP[fullKey] ?? LOCALE_MAP[lang] ?? enUS;
}
